import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="results-title" data-id="element-153" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-154" data-mp="28ddgf6fqs5p5">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-155" data-mp="2d6zun31k0hn2">
          Lo que dicen los docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-156" data-mp="2m63ei98jp12m">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-silver-400/25 bg-navy-900 p-6 shadow-sm shadow-black/20 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-157" data-mp="2r70tkcy9dezw" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-silver-300" aria-hidden="true" data-id="element-158" data-mp="3imzgrkj75gep" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-silver-100" data-id="element-159" data-mp="3ikwk4hnjgp10">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-silver-400/20 pt-4" data-id="element-160" data-mp="38otg1694mgbf">
                <span className="metal-silver flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-sm font-extrabold text-navy-950" data-id="element-161" data-mp="a6nvfko50ie4">
                  {initials}
                </span>
                <span data-id="element-162" data-mp="8gh79l8geft">
                  <b className="block text-sm text-white" data-id="element-163" data-mp="7ynajm1mcb2">{name}</b>
                  <small className="text-xs text-silver-300" data-id="element-164" data-mp="3scj00ratnca3">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}